import store from '@/store/core';
import { types } from '@/store/core/mutations';
import { talentCardRoutes } from 'packages/talent/TalentCardRoutes';
import { stageTalentCardRoutes } from '@/app/routes/talent-card';
import ImportCandidatesView from '@/app/views/job/ImportCandidatesView.vue';
// eslint-disable-next-line spaced-comment
//#region lazy imports
var JobsIndexView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/JobsIndexView.vue'); };
var JobSettingsView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/JobSettingsView.vue'); };
var SheetTalentView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/candidates/SheetTalentView.vue'); };
var PipelineStageView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/PipelineStageView.vue'); };
var PipelineStageTalentCardContainer = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/PipelineStageTalentCardContainer.vue'); };
var JobWizardView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/wizard/JobWizardView.vue'); };
var JobDetailsView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/wizard/JobDetailsView.vue'); };
var JobDescriptionView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/wizard/JobDescriptionView.vue'); };
var JobWizardAttributesView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/wizard/JobWizardAttributesView.vue'); };
var PipelineView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/PipelineView.vue'); };
var JobOverviewView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/JobOverviewView.vue'); };
var JobCloneView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/JobCloneView.vue'); };
var JobclusterView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/JobclusterIntegration.vue'); };
var OldMolView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/old_mol/MolView.vue'); };
var OldMolUpdateView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/old_mol/MolUpdateView.vue'); };
var OldMolStatusView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/old_mol/MolStatusView.vue'); };
var OldMolListingRemovedView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/old_mol/MolListingRemovedView.vue'); };
var OldMolPublishingJobFailedView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/old_mol/MolPublishingJobFailedView.vue'); };
var MolView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/mol/MolView.vue'); };
var MolCreateView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/mol/MolCreateView.vue'); };
var MolUpdateView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/mol/MolUpdateView.vue'); };
var MolStatusView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/mol/MolStatusView.vue'); };
var MolListingRemovedView = function () { return import(/* webpackChunkName: "job-mol-views" */ '@/app/views/job/mol/MolListingRemovedView.vue'); };
var CampaignView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/CampaignView.vue'); };
var CampaignOverview = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/CampaignOverview.vue'); };
var CampaignStatsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/CampaignStatsView.vue'); };
var PipelineConfigurationView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/PipelineConfigurationView.vue'); };
var JobTeamsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/JobTeamsView.vue'); };
var JobActionsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/JobActionsView.vue'); };
var JobAnalyticsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/JobAnalyticsView.vue'); };
var JobFormsSettingsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/JobFormsSettingsView.vue'); };
var JobIntegrationSettingsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/JobIntegrationSettingsView.vue'); };
var JobEmailSettingsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/JobEmailSettingsView.vue'); };
var EditJobDetailsView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/EditJobDetailsView.vue'); };
var EditJobDescriptionView = function () { return import(/* webpackChunkName: "job-views" */ '@/app/views/job/EditJobDescriptionView.vue'); };
var FormEditorView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/forms/FormEditorView.vue'); };
var NewFormView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/forms/NewFormView.vue'); };
var FormActionsView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/job/forms/FormActionsView.vue'); };
// eslint-disable-next-line spaced-comment
//#endregion
export var jobRoutes = {
    path: 'jobs',
    beforeEnter: function (to, from, next) {
        store.commit(types.SET_MODULE, 'ats');
        next();
    },
    component: {
        render: function (h) { return h('router-view'); },
    },
    children: [
        {
            path: '',
            name: 'Jobs.Index',
            component: JobsIndexView,
        },
        {
            path: 'archived',
            name: 'Jobs.Index.Archived',
            component: JobsIndexView,
            props: { showingArchived: true },
        },
        {
            path: 'new',
            name: 'Job.Create',
            component: JobWizardView,
            props: function (route) { var _a; return ({ referrerName: (_a = route.query) === null || _a === void 0 ? void 0 : _a.referrer }); },
            redirect: { name: 'Job.Wizard.Details' },
            children: [
                {
                    path: 'details',
                    name: 'Job.Wizard.Details',
                    component: JobDetailsView,
                },
                {
                    path: 'attributes',
                    name: 'Job.Wizard.Attributes',
                    component: JobWizardAttributesView,
                },
                {
                    path: 'description',
                    name: 'Job.Wizard.Description',
                    component: JobDescriptionView,
                },
            ],
        },
        {
            path: ':jobId',
            name: 'JobView',
            component: PipelineView,
            props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
            children: [
                {
                    path: 'pipeline',
                    redirect: { name: 'JobView' },
                },
                {
                    path: 'candidates/:candidateId',
                    name: 'TalentCard',
                    component: SheetTalentView,
                    redirect: {
                        name: 'TalentCard.Forms',
                    },
                    props: function (route) { var _a; return ({ candidateId: (_a = parseInt(route.params.candidateId)) !== null && _a !== void 0 ? _a : null }); },
                    children: talentCardRoutes,
                },
                {
                    path: 'stages/:stage/candidates',
                    name: 'Job.StageView',
                    props: function (route) { var _a; return ({ stageId: (_a = route.params.stage) !== null && _a !== void 0 ? _a : null }); },
                    component: PipelineStageView,
                    children: [
                        {
                            path: ':candidateId',
                            name: 'Stage.TalentCard',
                            component: PipelineStageTalentCardContainer,
                            redirect: {
                                name: 'Stage.TalentCard.Forms',
                            },
                            children: stageTalentCardRoutes,
                            props: function (route) { return ({ candidateId: route.params.candidateId }); },
                        },
                    ],
                },
            ],
        },
        {
            path: ':jobId/settings',
            name: 'Job.Settings',
            component: JobSettingsView,
            props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
            redirect: { name: 'Job.Details' },
            children: [
                {
                    path: 'details',
                    name: 'Job.Details',
                    component: EditJobDetailsView,
                    props: function (route) { return ({ jobId: route.params.jobId }); },
                },
                {
                    path: 'analytics',
                    name: 'Job.Analytics',
                    component: JobAnalyticsView,
                    props: function (route) { return ({ jobId: Number(route.params.jobId) }); },
                },
                {
                    path: 'overview',
                    name: 'Job.Overview',
                    component: JobOverviewView,
                    props: function (route) { return ({ jobId: route.params.jobId }); },
                },
                {
                    path: 'description',
                    name: 'Job.Description',
                    component: EditJobDescriptionView,
                    props: function (route) { return ({ jobId: route.params.jobId }); },
                },
                {
                    path: 'pipeline',
                    name: 'Job.Settings.PipelineConfiguration',
                    component: PipelineConfigurationView,
                    props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
                },
                {
                    path: 'teams',
                    name: 'Job.Settings.Teams',
                    component: JobTeamsView,
                },
                {
                    path: 'actions',
                    name: 'Job.Settings.Actions',
                    component: JobActionsView,
                },
                {
                    path: 'import',
                    name: 'Job.Settings.Import',
                    component: ImportCandidatesView,
                    props: function (route) { return ({ jobId: route.params.jobId }); },
                },
                {
                    path: 'integration',
                    name: 'Job.Settings.Integration',
                    component: JobIntegrationSettingsView,
                    props: function (route) { return ({ jobId: route.params.jobId }); },
                },
                {
                    path: 'forms',
                    name: 'Job.Settings.Forms',
                    component: JobFormsSettingsView,
                },
                {
                    path: 'emails',
                    name: 'Job.Settings.Emails',
                    component: JobEmailSettingsView,
                },
                {
                    path: 'jobcluster',
                    name: 'Job.Jobcluster',
                    component: JobclusterView,
                },
                {
                    path: 'old-mol',
                    name: 'Job.OldMol',
                    component: OldMolView,
                    props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
                    redirect: { name: 'Job.OldMol.Status' },
                    children: [
                        {
                            path: 'update',
                            name: 'Job.OldMol.Update',
                            component: OldMolUpdateView,
                        },
                        {
                            path: 'status',
                            name: 'Job.OldMol.Status',
                            component: OldMolStatusView,
                        },
                        {
                            path: 'removed',
                            name: 'Job.OldMol.Removed',
                            component: OldMolListingRemovedView,
                        },
                        {
                            path: 'uh-oh',
                            name: 'Job.OldMol.Failed',
                            component: OldMolPublishingJobFailedView,
                        },
                    ],
                },
                {
                    path: 'mol',
                    name: 'Job.Mol',
                    component: MolView,
                    props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
                    redirect: { name: 'Job.Mol.Status' },
                    children: [
                        {
                            path: 'create',
                            name: 'Job.Mol.Create',
                            component: MolCreateView,
                        },
                        {
                            path: 'update',
                            name: 'Job.Mol.Update',
                            component: MolUpdateView,
                        },
                        {
                            path: 'status',
                            name: 'Job.Mol.Status',
                            component: MolStatusView,
                        },
                        {
                            path: 'removed',
                            name: 'Job.Mol.Removed',
                            component: MolListingRemovedView,
                        },
                    ],
                },
                {
                    path: 'target-v2',
                    name: 'Job.Target.V2',
                    props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
                    component: CampaignView,
                },
                {
                    path: 'target-v2/edit',
                    name: 'Job.Target.V2.Edit',
                    props: function (route) { return ({
                        jobId: parseInt(route.params.jobId),
                        editingCampaign: true,
                        tab: parseInt(route.params.tab),
                    }); },
                    component: CampaignView,
                },
                {
                    path: 'target-v2/overview',
                    name: 'Job.Target.V2.Overview',
                    props: function (route) { return ({
                        jobId: parseInt(route.params.jobId),
                        minRange: parseInt(route.params.minRange),
                        maxRange: parseInt(route.params.maxRange),
                    }); },
                    component: CampaignOverview,
                },
                {
                    path: 'target-stats',
                    name: 'Job.Target.V2.stats',
                    component: CampaignStatsView,
                    props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
                },
                {
                    path: 'form',
                    name: 'Job.FormEditor',
                    component: { render: function (h) { return h('router-view'); } },
                    redirect: { name: 'Job.FormEditor.NewForm' },
                    children: [
                        {
                            path: 'new',
                            name: 'Job.FormEditor.NewForm',
                            component: NewFormView,
                            props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
                        },
                        {
                            path: ':formUuid/editor',
                            name: 'Job.FormEditor.EditForm',
                            component: FormEditorView,
                        },
                        {
                            path: ':formUuid/editor/:missingAttributes',
                            name: 'Job.FormEditor.EditForm.Copied',
                            component: FormEditorView,
                            props: function (route) { return ({
                                missingAttributes: parseInt(route.params.missingAttributes),
                            }); },
                        },
                        {
                            path: ':formUuid/actions',
                            name: 'Job.FormEditor.Actions',
                            component: FormActionsView,
                        },
                    ],
                },
            ],
        },
        {
            path: ':jobId/clone',
            name: 'Job.Clone',
            props: function (route) { return ({ jobId: parseInt(route.params.jobId) }); },
            component: JobCloneView,
        },
    ],
};
